export default "__VITE_ASSET__BBdCDmD1__"